/**
 * Created by piotr.pozniak@thebeaverhead.com on 09/11/2021.
 */

import React from "react";
import DesignTooltip from "../Builder/Input/DesignTooltip";
import classNames from "classnames";

/**
 *
 * @param {Object} tooltip
 * @param {string} tooltip.help
 * @param {string} tooltip.url
 * @param {string} fieldName
 * @param {string} label
 * @param {boolean} checked
 * @param {function} onChange
 * @param {string} className
 * @param {string} variant
 * @returns {Element}
 * @constructor
 */
const RadioInput = ({
  tooltip,
  fieldName,
  label,
  checked,
  onChange,
  className = "",
  variant = "primary",
}) => {
  const _tooltip = tooltip ? <DesignTooltip help={tooltip} /> : null;

  return (
    <div className={classNames("design-element checkbox", className)}>
      <label className={"option-label"}>
        {label}
        {_tooltip}
      </label>

      <div className="material-switch pull-right">
        <input
          id={fieldName}
          type="checkbox"
          checked={checked}
          onChange={onChange(fieldName)}
        />
        <label htmlFor={fieldName} className={`badge-${variant}`} />
      </div>
    </div>
  );
};

export default RadioInput;
